class AuthService {
    constructor() {

    };
    getToken() {
        return '';
    };
}
const authService = new AuthService();
export default authService;